import { useState, useEffect } from 'react';

const LearnFromTheBest = () => {
  const [instructors] = useState([
    {
      id: 1,
      image: '/speakers/2.png',
      name: 'Jerome Bell',
      role: 'Marketing Coordinator',
      rating: 4.5,
      students: 692,
      courses: 15
    },
    {
      id: 2,
      image: '/speakers/1.png',
      name: 'Bessie Cooper',
      role: 'President of Sales',
      rating: 4.8,
      students: 856,
      courses: 22
    },
    {
      id: 3,
      image: '/speakers/3.png',
      name: 'Kristin Watson',
      role: 'Nursing Assistant',
      rating: 4.6,
      students: 524,
      courses: 18
    },
    {
      id: 4,
      image: '/speakers/1.png',
      name: 'Robert Johnson',
      role: 'Software Developer',
      rating: 4.9,
      students: 1203,
      courses: 28
    },
    {
      id: 5,
      image: '/speakers/2.png',
      name: 'Sarah Williams',
      role: 'UI/UX Designer',
      rating: 4.7,
      students: 967,
      courses: 24
    },
    {
      id: 6,
      image: '/speakers/3.png',
      name: 'Michael Brown',
      role: 'Data Scientist',
      rating: 4.8,
      students: 743,
      courses: 19
    }
  ]);

  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(3);
  const [isMobile, setIsMobile] = useState(false);

  // Gestion de la responsivité
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 1024); // Définit comme mobile en dessous de 1024px

      if (width < 640) {
        setSlidesPerView(1);
      } else if (width < 768) {
        setSlidesPerView(2);
      } else if (width < 1024) {
        setSlidesPerView(2);
      } else if (width < 1280) {
        setSlidesPerView(3);
      } else {
        setSlidesPerView(3);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const totalSlides = Math.ceil(instructors.length / slidesPerView);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const StarIcon = () => (
    <svg className="w-3 h-3 fill-current text-yellow-500" viewBox="0 0 24 24">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  );

  const StudentIcon = () => (
    <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-3-5.197m-3 5.197v1z" />
    </svg>
  );

  const CourseIcon = () => (
    <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
    </svg>
  );

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-8 lg:gap-12">
          {/* Section titre et description - Cachée sur mobile */}
          <div className="xl:col-span-3 lg:col-span-4 hidden lg:block">
            <div className="max-w-md">
              <h2 className="text-3xl lg:text-title font-bold text-dark-1 mb-6">
                Apprends avec les meilleurs
              </h2>
              <div className="inline-block">
                <a href="/instructors-list">
                  <button className="group bg-red-3 text-button text-red-4 px-6 py-3 rounded-full font-semibold transition-all
                    duration-300 flex items-center space-x-2 transform hover:scale-x-95">
                    <span>Voir tous les instructeurs</span>
                    <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7l10 10M17 7v10H7" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
          </div>

          {/* Section carousel instructeurs */}
          <div className="xl:col-span-8 xl:col-start-5 lg:col-span-8">
            {/* Titre visible uniquement sur mobile */}
            <div className="lg:hidden text-center mb-8">
              <h2 className="text-3xl font-bold text-dark-1">
                Apprends avec les meilleurs
              </h2>
            </div>
            
            <div className="relative overflow-hidden">
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * (100 / slidesPerView)}%)` }}
              >
                {instructors.map((instructor) => (
                  <div
                    key={instructor.id}
                    className="flex-shrink-0 px-3 sm:px-4"
                    style={{ width: `${100 / slidesPerView}%` }}
                  >
                    <div className="bg-gray-50 rounded-2xl transition-all duration-300">
                      <div className="flex flex-col items-center text-center">
                        {/* Image instructeur */}
                        <div className="md:w-40 md:h-40 w-24 h-24 rounded-full overflow-hidden mb-4">
                          <img
                            src={instructor.image}
                            alt={instructor.name}
                            className="w-full h-full object-cover"
                          />
                        </div>

                        {/* Note */}
                        <div className="flex items-center mb-3">
                          <StarIcon />
                          <span className="text-yellow-500 text-sm ml-1">{instructor.rating}</span>
                        </div>

                        {/* Nom et rôle */}
                        <h5 className="text-[17px] text-dark-1 mb-1">
                          {instructor.name}
                        </h5>
                        <p className="text-gray-600 text-sm mb-4">
                          {instructor.role}
                        </p>

                        {/* Statistiques */}
                        <div className="flex space-x-4 items-center">
                          <div className="flex items-center space-x-2">
                            <StudentIcon />
                            <span className="text-xs flex items-center text-gray-700">{instructor.students} Students</span>
                          </div>
                          <div className="flex items-center space-x-2">
                            <CourseIcon />
                            <span className="text-xs flex items-center text-gray-700">{instructor.courses} Courses</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Navigation */}
            <div className="flex justify-center items-center mt-12 space-x-4">
              <div className="flex space-x-2">
                {Array.from({ length: totalSlides }).map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`w-2 h-2 rounded-full transition-all duration-300 ${index === currentSlide
                        ? 'bg-red-4 scale-110'
                        : 'bg-gray-300 hover:bg-gray-400'
                      }`}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            </div>

            {/* Bouton visible uniquement sur mobile */}
            <div className="lg:hidden flex justify-center mt-8">
              <a href="/instructors-list">
                <button className="group bg-red-3 text-button text-red-4 px-6 py-3 rounded-full font-semibold transition-all
                  duration-300 flex items-center space-x-2 transform hover:scale-x-95">
                  <span>Voir tous les instructeurs</span>
                  <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7l10 10M17 7v10H7" />
                  </svg>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LearnFromTheBest;